import { createTheme } from '@mui/material';

export const LightTheme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#101246',
            contrastText: '#FFFFFF'
        },
        secondary: {
            main: '#5BB2DD',
            contrastText: '#101246'
        },
        error: {
            main: '#FF5C5C'
        },
        warning: {
            main: '#FFC1AD',
            contrastText: '#101246'
        },
        info: {
            main: '#5BB2DD',
            contrastText: '#101246'
        },
        background: {
            default: '#F7F8FA',
            paper: '#FFFFFF'
        },
        text: {
            primary: '#263044',
            secondary: '#657085',
            disabled: '#8A8F98'
        },
        divider: '#E1E7EF'
    },
    typography: {
        fontFamily: '"Open Sans", "Roboto", "Arial", sans-serif',
        h1: { fontFamily: '"DIN 2014 NOW", "Open Sans", "Roboto", sans-serif', fontWeight: 700 },
        h2: { fontFamily: '"DIN 2014 NOW", "Open Sans", "Roboto", sans-serif', fontWeight: 700 },
        h3: { fontFamily: '"DIN 2014 NOW", "Open Sans", "Roboto", sans-serif', fontWeight: 700 },
        h4: { fontFamily: '"DIN 2014 NOW", "Open Sans", "Roboto", sans-serif', fontWeight: 700 },
        h5: { fontFamily: '"DIN 2014 NOW", "Open Sans", "Roboto", sans-serif', fontWeight: 700 },
        h6: { fontFamily: '"DIN 2014 NOW", "Open Sans", "Roboto", sans-serif', fontWeight: 700 },
        button: {
            fontWeight: 700,
            textTransform: 'none'
        }
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 6,
                    borderColor: '#9AA5B7'
                }
            }
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    color: '#263044'
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: {
                    fontWeight: 500
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#5BB2DD'
                    }
                }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    '&.Mui-focused': {
                        color: '#006B8D'
                    }
                }
            }
        }
    }
});
